<template>
    <div :class="[ 'toggle-switch', { checked, disabled } ]" @click="onClick">
        <!-- Fallback element if someone want to send data via form
            rather than AJAX. -->
        <input
            v-model="checked"
            :name="name"
            type="checkbox"
        >
        <span class="toggle">&nbsp;</span>
    </div>
</template>
<script>
export default {
    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
        locked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        checked: false,
    }),

    watch: {
        value: {
            immediate: true,

            /**
             * Updates `checked` state based on `value` prop.
             *
             * @param {boolean} value Value.
             */
            handler(value) {
                this.checked = value;
            },
        },
    },

    methods: {
        /**
         * Handles click event on components.
         */
        onClick() {
            if (this.disabled) {
                return;
            }

            const checked = ! this.checked;
            this.$emit('click', checked);

            // Do not change state of component if is locked.
            if (this.locked) {
                return;
            }

            this.checked = checked;
            this.$emit('change', this.checked);
        },
    },
};
</script>
